// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".public-topbar .v-toolbar__content{grid-template-columns:minmax(0,auto) minmax(0,auto) minmax(min-content,1fr);margin-left:auto;margin-right:auto;padding-left:var(--z-the-landscape-inline-spacing);padding-right:var(--z-the-landscape-inline-spacing)}.public-topbar__pages-menu{align-self:stretch;margin-left:-8px;margin-right:-8px;margin-top:-8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
